import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const Newspaper = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="69"
    viewBox="0 0 55 69"
  >
    <g id="News" transform="translate(-52.397)">
      <path
        id="Path_1940"
        data-name="Path 1940"
        d="M56.038,35.93a3.646,3.646,0,0,0-3.64,3.632V95.246h48.125V35.93Z"
        transform="translate(-0.001 -31.088)"
        fill="#dadada"
      />
      <path
        id="Path_1941"
        data-name="Path 1941"
        d="M107.078,395.317v7.251H65.02a3.632,3.632,0,1,0,0,7.263h41.654a7.262,7.262,0,0,0,.4-14.514Z"
        transform="translate(-7.77 -342.042)"
        fill="#c2c2c2"
      />
      <path
        id="Path_1942"
        data-name="Path 1942"
        d="M100.118,0H58.868V53.263a1.212,1.212,0,0,0,1.213,1.21H98.9a6.053,6.053,0,1,1,0,12.105H57.25a2.421,2.421,0,1,1,0-4.842H98.1a1.21,1.21,0,1,0,0-2.421H57.25a4.842,4.842,0,1,0,0,9.684H98.9a8.493,8.493,0,0,0,8.493-8.474V7.263A7.293,7.293,0,0,0,100.118,0Z"
        fill="#efefef"
      />
      <g
        id="Group_64792"
        data-name="Group 64792"
        transform="translate(65.743 6.86)"
      >
        <path
          id="Path_1943"
          data-name="Path 1943"
          d="M152.418,90.445a1.212,1.212,0,0,1-1.213-1.21V52.111a1.213,1.213,0,0,1,2.426,0V89.234A1.212,1.212,0,0,1,152.418,90.445Z"
          transform="translate(-151.205 -50.901)"
          fill="#c2c2c2"
        />
        <path
          id="Path_1944"
          data-name="Path 1944"
          d="M200.325,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,200.325,245.883Z"
          transform="translate(-192.641 -206.34)"
          fill="#c2c2c2"
        />
        <path
          id="Path_1945"
          data-name="Path 1945"
          d="M248.231,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,248.231,245.883Z"
          transform="translate(-234.077 -206.34)"
          fill="#c2c2c2"
        />
        <path
          id="Path_1946"
          data-name="Path 1946"
          d="M296.137,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,296.137,245.883Z"
          transform="translate(-275.512 -206.34)"
          fill="#c2c2c2"
        />
      </g>
      <rect
        id="Rectangle_2552"
        data-name="Rectangle 2552"
        width="19.412"
        height="19.368"
        transform="translate(73.427 8.07)"
        fill="#c2c2c2"
      />
      <g
        id="Group_64793"
        data-name="Group 64793"
        transform="translate(91.625 6.86)"
      >
        <path
          id="Path_1947"
          data-name="Path 1947"
          d="M344.044,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,344.044,245.883Z"
          transform="translate(-342.831 -206.34)"
          fill="#c2c2c2"
        />
        <path
          id="Path_1948"
          data-name="Path 1948"
          d="M391.95,90.445a1.212,1.212,0,0,1-1.213-1.21V52.111a1.213,1.213,0,0,1,2.426,0V89.234A1.212,1.212,0,0,1,391.95,90.445Z"
          transform="translate(-384.266 -50.901)"
          fill="#c2c2c2"
        />
      </g>
    </g>
  </Icon>
);

export default Newspaper;



// WEBPACK FOOTER //
// ./src/components/Icons/Newspaper.js